import React, { useEffect } from "react";

import Section from "../../../components/Section";

import style from "./style.module.css";

export default function TermlyPolicy(props) {
    const {
        termly_policy_id,
    } = props;

    useEffect(() => {
        const scriptId = 'termly-jssdk';

        // Check if the script already exists
        if (document.getElementById(scriptId)) return;

        const script = document.createElement('script');
        script.id = scriptId;
        script.src = "https://app.termly.io/embed-policy.min.js";

        // Insert the script before the target script tag in the document
        const target = document.getElementsByTagName('script')[0];
        if (target) {
            target?.parentNode?.insertBefore(script, target);
        }

        return () => {
            const existingScript = document.getElementById(scriptId);
            if (existingScript) {
                existingScript.remove();
            }
        };
    }, [])

    return (
        <Section className={`${style.termlyPolicy}`}>
            <div name="termly-embed" data-id={termly_policy_id}></div>
        </Section>
    )
};